export default __webpack_public_path__ + "static/media/bca.c2e5a392.png";